<template>
  <div id="purchase-invoices" class="px-4 py-4">
    <purchase-invoice-list />
  </div>
</template>
<script>
import PurchaseInvoiceList from "@/components/finance/PurchaseInvoiceList.vue";
export default {
  components: {
    PurchaseInvoiceList
  }
};
</script>
